"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checklistStatus = exports.MaintenanceIntervalType = void 0;
var MaintenanceIntervalType;
(function (MaintenanceIntervalType) {
    MaintenanceIntervalType["HourmeterReading"] = "hourmeter reading";
    MaintenanceIntervalType["OdometerReading"] = "odometer reading";
    MaintenanceIntervalType["NumberOfDays"] = "days";
})(MaintenanceIntervalType = exports.MaintenanceIntervalType || (exports.MaintenanceIntervalType = {}));
var checklistStatus;
(function (checklistStatus) {
    checklistStatus["Pass"] = "pass";
    checklistStatus["Fail"] = "fail";
})(checklistStatus = exports.checklistStatus || (exports.checklistStatus = {}));
//# sourceMappingURL=maintenance.js.map